import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { ExportIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ExportPopup from 'components/export/confirmation';
import { confirmationOpenSelector, closeConfirmation, createDelayedExport } from './slice';
const styledButtonCss = "sz3uoe";
const StyledButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const ExportButton = ({
  eventId,
  hideIcon = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const confirmationOpen = useSelector(confirmationOpenSelector);
  return <>
      <StyledButton aria-label={I18n.t('publisher.action.export')} {...props} onClick={() => dispatch(createDelayedExport({
      eventId
    }))}>
        {!hideIcon && <ExportIcon />}
        {I18n.t('publisher.action.export')}
      </StyledButton>
      {confirmationOpen && <ExportPopup onConfirm={() => dispatch(closeConfirmation())} />}
    </>;
};

require("./button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./button.js");